<template>
<div>
    <el-dialog :title="title" class="c-dialog-fixed" width="700px" :visible.sync="show" :append-to-body="inDialog" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" center top="5vh" @open="openDialog" @close="closeDialog">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="mini" status-icon class="c-form-mini">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="SMTP服务器地址:" prop="password">

                        <el-input v-model="form.host" style="width: 200px;" placeholder="请输入SMTP服务器地址"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="邮箱:" prop="username">
                        <el-input v-model="form.username" style="width: 200px;" placeholder="请输入邮箱地址"></el-input>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="邮箱授权码:" prop="password">

                        <el-input v-model="form.password" style="width: 200px;" placeholder="请输入邮箱授权码"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="show = false">
                取消
            </el-button>
            <el-button type="primary" @click="title === '添加记录' ? addData() : editData()">
                确认
            </el-button>
        </div>
    </el-dialog>

</div>
</template>

<script>
// import waves from '@/directive/waves'
import {
    template_add,
    email_outbox_add,
    email_outbox_edit,
    email_outbox_review,
    country_list_all,
    template_edit
} from '../../api';

const formInit = {
    host: '',
    username: '',
    password: '',

}
export default {
    name: 'AddOutbox',
    // directives: { waves },
    components: {

    },
    props: {
        module: {
            type: String,
            default: ''
        },
        inDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            title: '新增',
            loading: false,
            form: {
                ...formInit
            },
            countrylist: [],

            typelist: [{
                    value: '佛',
                    label: '佛'
                },
                {
                    value: '基督',
                    label: '基督'
                },
                {
                    value: '无宗教',
                    label: '无宗教'
                }
            ],

            statuslist: [{
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            show: false,
            updated: false,
            nowUser: '',
            lander: {},
            file: {},
            query: {},
            rules: {
                itemcode: [{
                    required: true,
                    pattern: /^\d{13}$/,
                    message: '请输入13位纯数字物料编码',
                    trigger: ''
                }],

            }
        }
    },
    created() {

    },
    mounted() {
        this.nowUser = localStorage.getItem('account')
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.getCountry();

    },
    methods: {
        openDialog() {
            this.$nextTick(() => {
                if (this.resolve) {
                    this.resolve(this)
                }
            })
        },
        //获取国家清单数据
        getCountry() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            country_list_all(this.query).then((res) => {
                if (res.data.status == 1) {
                    this.countrylist = res.data.obj
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        open() {
            this.show = true
            return new Promise((resolve, reject) => {
                this.resolve = resolve
            })
        },
        clearValidate() {
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.clearValidate()
            })
        },
        resetFields() {
            this.updated = false
            this.form = {
                ...formInit
            }
            this.clearValidate()
            return this
        },
        closeDialog() {
            const vm = this
            vm.form = {
                ...formInit
            }
            this.resetFields()
        }, // 关闭弹窗操作
        update() {
            this.loading = false
            this.updated = true
            this.show = false
            this.$emit('addRefresh')
            this.resetFields()
        },

        updateForEdit() {
            this.$parent.$emit('addRefresh')
            this.loading = false
            this.updated = true
            this.show = false
            this.resetFields()
        },
        initData(data, title) {
            if (title == 'add') {
                this.title = "添加记录"
            } else {
                this.title = "编辑数据"
            }
            this.assign(data)
            this.clearValidate()
        },
        assign(data) {
            this.form = {
                ...this.form,
                ...data
            }
            return this
        },

        addData() {
            this.$refs['form'].validate(() => {
                this.form.uid = this.lander.uid;
                this.form.token = this.lander.token;
                email_outbox_add(this.form).then((res) => {
                    this.$notify({
                        title: '成功',
                        message: '编辑成功',
                        type: 'success',
                        duration: 2000
                    })
                    this.update()
                })

            })
        },
        editData() {

            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.form.uid = this.lander.uid;
                    this.form.token = this.lander.token;

                    template_edit(this.form).then((res) => {
                        this.$notify({
                            title: '成功',
                            message: '编辑成功',
                            type: 'success',
                            duration: 2000
                        })
                        this.update()
                    })
                }
            })
        },

    }
}
</script>

<style lang="scss" scoped>
</style>
